export { handleError, ErrorCode } from './errorHandler'
import {
  updateDiscordChannelApi,
  createOrUpdateUserAccountApi,
  createOrUpdatePrivyUserApi,
  updateUserProfileDataApi,
  verifySignInTokenApi,
  getReferListApi,
} from './api'
import { getBetTransactionData } from './getBetTransactionData'
import compressData from './compressData'
import {
  type BetData,
  createBetslipData,
  createComboDiscordEmbed,
  createDiscordEmbed,
  type DiscordEmbed,
} from './discordEmbedHelper'
import { getAuthMethodId } from './getAuthMethod'
import { walletCache, CACHE_KEYS, TTL } from './cache'

export {
  updateUserProfileDataApi,
  createOrUpdateUserAccountApi,
  createOrUpdatePrivyUserApi,
  updateDiscordChannelApi,
  verifySignInTokenApi,
  getReferListApi,
  getBetTransactionData,
  compressData,
  createBetslipData,
  createComboDiscordEmbed,
  createDiscordEmbed,
  getAuthMethodId,
  walletCache,
  CACHE_KEYS,
  TTL,
}

export type { BetData, DiscordEmbed }
